import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
// import QuoteList from './components/QuoteList';
// import QuoteDetails from './components/QuoteDetails';

export default function Quotes({ status }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [reload, setReload] = useState();
  const [show, setShow] = useState(false);
  const [quoteId, setQuoteId] = useState(
    location.hash && location.hash.length > 1
      ? location.hash.substring(1, location.hash.length)
      : null
  );

  const handleClose = () => {
    navigate(-1);
  };

  React.useEffect(() => {
    if (location.hash !== quoteId) {
      setQuoteId(location.hash);
      if (location.hash && location.hash.length > 1) {
        setQuoteId(location.hash.substring(1, location.hash.length));
      } else {
        setQuoteId(null);
      }
    }
  }, [location.hash, quoteId]);

  React.useEffect(() => {
    if (quoteId && quoteId.length > 1) {
      setShow(true);
    } else {
      console.log('no quote id');
      setShow(false);
    }
  }, [quoteId]);

  return (
    <>
      <div className="page-content quotes">
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 col-md-12 col-xl-3">
              <h1>
                <i className="fa-light fa-file-invoice me-2"></i>
                Quotes
              </h1>
            </div>
          </div>

          {/* <QuoteList status={status} location={location} reload={reload} /> */}

          <Modal
            show={show}
            onHide={handleClose}
            dialogClassName="modal-dialog-centered modal-xl modal-fullscreen-xl-down"
          >
            {/* <QuoteDetails id={quoteId} key={quoteId} /> */}
          </Modal>
        </div>
      </div>
    </>
  );
}
